import { CategoryHighlightBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpCategoryHighlightBlock } from './AmpCategoryHighlightBlock';
import { CategoryHighlightBlock } from './CategoryHighlightBlock';

export const CategoryHighlightBlockMapping: BlockMapping<CategoryHighlightBlockData> =
  {
    invariant: [],
    width: 'GRID',
    Component: CategoryHighlightBlock,
    AmpComponent: AmpCategoryHighlightBlock,
  };
